import { ConsentFormComponent } from './form/consent-form/consent-form.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeShowComponent } from "./employee/employee-show/employee-show.component";
import { NoAuthGuard } from "./login/no-auth-guard.service";
import { LotListComponent } from "./lot/lot-list/lot-list.component";
import { LotShowComponent } from "./lot/lot-show/lot-show.component";
import { FormShowComponent } from "./form/form-show/form-show.component";
import { LoginComponent } from "./login/login.component";
import { SearchResultComponent } from "./search-result/search-result.component";
import { SearchFormComponent } from "./search-form/search-form.component";
import { AccessDeniedComponent } from "./common/access-denied/access-denied.component";
import { AuthGuard } from "./core/services/auth-guard.service";
import { InviteShowComponent } from './form/invite-show/invite-show.component';
import { PasswordResetComponent } from "./login/password-reset/password-reset.component";
import { ForgotPasswordComponent } from "./login/forgot-password/forgot-password.component";
import { FormInviteesListComponent } from "./form/form-invitees-list/form-invitees-list.component";
import { CreateRedirectedFormInviteesComponent } from "./form/create-redirected-form-invitees/create-redirected-form-invitees.component";
import { RevertFormComponent } from './form/revert-form/revert-form.component';
import { OcrComponent } from './ocr/ocr.component';
import { OcrDocumentValidatorComponent } from './ocr/ocr-document-validator/ocr-document-validator.component';
import { OcrAddressComponent } from './ocr/ocr-address/ocr-address.component';
import { OcrSucessPageComponent } from './ocr/ocr-sucess-page/ocr-sucess-page.component';
import { ZohoAuthenticatePageComponent } from './zoho/zoho-authenticate/zoho-authenticate-page.component';


const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'login', component: LoginComponent, canActivate: [NoAuthGuard] },
    { path: 'lots/:id/ocr', component: OcrComponent, canActivate: [AuthGuard] },
    { path: 'lots/:id/ocr/address', component: OcrAddressComponent, canActivate: [AuthGuard] },
    {path:  'lots/:id/ocr/success', component: OcrSucessPageComponent, canActivate: [AuthGuard] },
    { path: 'maintenance', redirectTo: 'home' },
    //{path: '', component: LotListComponent, canActivate: [AuthGuard]},
    { path: 'home', component: LotListComponent, canActivate: [AuthGuard] },
    { path: 'employees/:id', component: EmployeeShowComponent, canActivate: [AuthGuard] },
    { path: 'employees/get-documents', component: EmployeeShowComponent, canActivate: [AuthGuard] },
    { path: 'lots', component: LotListComponent, canActivate: [AuthGuard] },
    { path: 'lots/:id', component: LotShowComponent, canActivate: [AuthGuard] },
    { path: 'search-results', component: SearchResultComponent, canActivate: [AuthGuard] },
    { path: 'search', component: SearchFormComponent, canActivate: [AuthGuard] },
    { path: 'all-invitees', component: FormInviteesListComponent, canActivate: [AuthGuard] },
    { path: 'create-candidate/:token', component: CreateRedirectedFormInviteesComponent, canActivate: [NoAuthGuard] },
    { path: 'invites/:token', component: InviteShowComponent, canActivate: [NoAuthGuard] },
    { path: 'revert-forms/:token', component: RevertFormComponent, canActivate: [NoAuthGuard] },
    { path: 'access-denied', component: AccessDeniedComponent, canActivate: [NoAuthGuard] },
    { path: 'forms', component: FormShowComponent, canActivate: [NoAuthGuard] },
    { path: 'forms/:token', component: FormShowComponent, canActivate: [NoAuthGuard] },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoAuthGuard] },
    { path: 'password-reset/:token', component: PasswordResetComponent, canActivate: [NoAuthGuard] },
    { path: 'candidate/consent/:token', component: ConsentFormComponent, canActivate: [NoAuthGuard] },
    { path: 'integrations/zoho', component: ZohoAuthenticatePageComponent, canActivate: [ AuthGuard ] },
];


@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/app-routing.module.ts